// ========================================
// CART VIEW BUTTONS - WITH HIDDEN DATA
// ========================================

console.log("🔄 Cart buttons script loaded");

// ========================================
// MAIN FUNCTION - Add buttons to cart and hide data
// ========================================

function addCartViewButtons() {
    console.log("🔍 Looking for cart items...");
    
    // Find all cart items using your specific structure
    const cartItems = document.querySelectorAll('tr.cart-item');
    
    console.log(`📦 Found ${cartItems.length} cart items`);
    
    if (cartItems.length === 0) {
        console.log("⚠️ No cart items found, retrying...");
        return;
    }
    
    cartItems.forEach(function(item, index) {
        // Check if buttons already exist
        if (item.querySelector('.cart-view-buttons-container')) {
            console.log(`✅ Buttons already exist for item ${index}`);
            return;
        }
        
        console.log(`🔧 Processing item ${index}...`);
        
        // Get all product options
        const productOptions = item.querySelectorAll('.product-option');
        console.log(`📋 Found ${productOptions.length} product options`);
        
        let allData = {};
        let hasData = false;
        let measurementData = {};
        let customizationData = {};
        
        productOptions.forEach(function(option) {
            const dt = option.querySelector('dt');
            const dd = option.querySelector('dd');
            
            if (dt && dd) {
                const key = dt.textContent.trim().replace(':', '');
                const value = dd.textContent.trim();
                allData[key] = value;
                hasData = true;
                
                // Separate measurement data
                const measurementKeys = ['height', 'weight', 'size', 'neck', 'shoulder', 
                                         'stomach', 'bicep', 'sleeve', 'shirtlength', 
                                         'wrist', 'profile', 'user', 'name', 'age', 
                                         'measurement'];
                
                const isMeasurement = measurementKeys.some(k => key.toLowerCase().includes(k));
                if (isMeasurement) {
                    measurementData[key] = value;
                } else {
                    customizationData[key] = value;
                }
                
                // HIDE the product-option divs
                option.style.display = 'none';
            }
        });
        
        // Also hide the dl container if it exists
        const dlContainer = item.querySelector('dl');
        if (dlContainer) {
            dlContainer.style.display = 'none';
        }
        
        // Get product name
        const productName = item.querySelector('.cart-item__name')?.textContent?.trim() || '';
        if (productName) {
            allData['Product'] = productName;
            customizationData['Product'] = productName;
            measurementData['Product'] = productName;
        }
        
        // Get product price
        const productPrice = item.querySelector('.cart-item__price-wrapper .price')?.textContent?.trim() || '';
        if (productPrice) {
            allData['Price'] = productPrice;
            customizationData['Price'] = productPrice;
        }
        
        if (!hasData) {
            console.log(`⚠️ No data found for item ${index}`);
            return;
        }
        
        console.log(`✅ Adding buttons to item ${index}`);
        
        // Find the details area
        const detailsArea = item.querySelector('.cart-item__details');
        if (!detailsArea) {
            console.log(`⚠️ No details area found for item ${index}`);
            return;
        }
        
        // Create container for buttons
        const btnContainer = document.createElement('div');
        btnContainer.className = 'cart-view-buttons-container';
        btnContainer.style.cssText = `
            display: flex;
            gap: 10px;
            margin-top: 12px;
            margin-bottom: 8px;
         flex-direction: row;
            padding: 10px 0;

              flex-direction: row;
        `;
        
        // BUTTON 1: Customization Summary
        if (Object.keys(customizationData).length > 0) {
            const btn1 = document.createElement('button');
            btn1.innerHTML = `<svg fill="#000000" width="20px" height="20px" viewBox="-1 0 19 19" xmlns="http://www.w3.org/2000/svg" class="cf-icon-svg"><path d="m15.867 7.593-1.534.967a.544.544 0 0 1-.698-.118l-.762-.957v7.256a.476.476 0 0 1-.475.475h-7.79a.476.476 0 0 1-.475-.475V7.477l-.769.965a.544.544 0 0 1-.697.118l-1.535-.967a.387.387 0 0 1-.083-.607l2.245-2.492a2.814 2.814 0 0 1 2.092-.932h.935a2.374 2.374 0 0 0 4.364 0h.934a2.816 2.816 0 0 1 2.093.933l2.24 2.49a.388.388 0 0 1-.085.608z"/></svg>`;
            btn1.className = 'cart-btn-customization';
            btn1.style.cssText = `
                background: rgb(230 230 230);
                color: white;
                border: none;
                padding: 8px 10px;
                border-radius: 6px;
                cursor: pointer;
                font-size: 13px;
                font-weight: 600;
                font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;             
                transition: all 0.3s ease;          
                 width: 40px;
                     justify-content: center;
                    align-items: center;
                    display: flex;
            `;
            
            btn1.onmouseenter = function() {
                this.style.transform = 'scale(1.05)';
            
            };
            btn1.onmouseleave = function() {
                this.style.transform = 'scale(1)';
            
            };
            
            btn1.onclick = function(e) {
                e.preventDefault();
                e.stopPropagation();
                showDataPopup(customizationData, '👕 Customization Summary');
            };
            
            btnContainer.appendChild(btn1);
        }
        
        // BUTTON 2: Measurement Summary
        if (Object.keys(measurementData).length > 0) {
            const btn2 = document.createElement('button');
           btn2.innerHTML = `
        <svg viewBox="0 0 498.226 498.226" width="18" height="18" style="fill: black; flex-shrink: 0;">
            <path d="M48,362.77H15c-8.284,0-15,6.716-15,15s6.716,15,15,15h33c8.284,0,15-6.716,15-15S56.284,362.77,48,362.77z M160,362.77h-56c-8.284,0-15,6.716-15,15s6.716,15,15,15h56c8.284,0,15-6.716,15-15S168.284,362.77,160,362.77z M272,362.77h-56c-8.284,0-15,6.716-15,15s6.716,15,15,15h56c8.283,0,15-6.716,15-15S280.283,362.77,272,362.77z M384,362.77h-56c-8.285,0-15,6.716-15,15s6.715,15,15,15h56c8.283,0,15-6.716,15-15S392.283,362.77,384,362.77z M473,362.77h-33c-8.285,0-15,6.716-15,15s6.715,15,15,15h33c8.283,0,15-6.716,15-15S481.283,362.77,473,362.77z M498.018,269.898c-0.83-8.449-4.072-16.648-9.375-23.713c-3.037-4.043-6.693-7.655-10.861-10.73c-11.111-8.204-25.434-12.481-40.318-12.03c-0.035,0-0.076,0.001-0.109,0.006l-3.316,0.191c-8.125,0.623-16.293,2.757-23.631,6.172c-0.031,0.014-0.059,0.029-0.098,0.047c-2.541,1.268-3.348,1.706-3.656,1.886c-22.951,12.417-39.941,17.467-51.41,19.364c5.018-10.484,14.604-25.395,32.92-43.979c0.26-0.248,0.902-0.905,2.832-2.991c0.021-0.026,0.049-0.05,0.066-0.08c5.324-6.092,9.65-13.348,12.539-21.046l1.08-3.06c0.018-0.036,0.027-0.069,0.035-0.104c6.344-19.624,3.408-40.967-7.66-55.702c-0.004-0.005-0.004-0.005-0.004-0.005c-3.711-4.938-8.256-9.029-13.518-12.161c-9.08-5.392-19.957-7.54-30.635-6.041c-9.844,1.376-19.463,5.675-27.801,12.426c-4.797,3.886-9.078,8.524-12.693,13.728c-4.875,7.513-7.195,12.85-8.467,16.531c-7.058,20.049-4.478,42.221,6.883,57.341c1.93,2.569,4.119,4.956,6.51,7.091c1.332,1.195,2.729,2.311,4.176,3.328l-16.455,38.166l-125.055,22.056c-0.451,0.065-0.906,0.131-1.361,0.194c-2.822,0.41-5.75,0.831-8.705,1.957c-10.935,4.161-17.211,14.049-20.543,21.606c-1.619,3.674-2.673,6.762-3.3,9.71l-1.657,7.562c-0.27,1.225,0.075,2.486,0.914,3.415c0.843,0.922,2.077,1.374,3.314,1.222l136.215-17.099l-19.999,48.164h48.378l26.133-55.168l39.801-4.988c1.59,4.652,3.902,9.008,6.898,12.994c10.838,14.43,30.105,23.193,50.291,22.874c23.186-0.369,44.266-11.931,55.008-30.171C496.621,289.97,498.973,279.687,498.018,269.898z M339.713,191.282c-1.57-1.064-2.963-2.396-4.137-3.959c-4.971-6.613-5.303-16.15-3.965-22.867c1.875-9.369,7.051-17.786,14.193-23.081c6.604-4.896,14.105-6.282,20.062-3.705l0.004,0.001c0.006,0,0.01,0.001,0.018,0.004c2.551,1.104,4.732,2.84,6.475,5.151c3.762,5.014,5.443,12.98,4.381,20.792c-1.406,10.337-6.998,19.907-14.961,25.601C356.15,193.244,346.998,196.197,339.713,191.282z M467.166,276.095c-0.367,3.5-1.936,7.018-4.525,10.171c-5.666,6.898-15.287,11.293-25.742,11.752c-8.484,0.373-19.736-2.146-25.877-10.317c-0.221-0.294-0.428-0.592-0.631-0.895c-4.033-6.01-3.418-13.96,1.559-20.264c4.887-6.197,13-10.489,22.26-11.778l1.068-0.136c8.68-0.958,20.498,0.884,27.666,8.941c0.334,0.372,0.646,0.762,0.947,1.158C466.422,268.1,467.586,272.137,467.166,276.095z"/>
        </svg>  
    `;
            btn2.className = 'cart-btn-measurement';
            btn2.style.cssText = `
              background: #666;
        background: rgb(230 230 230);
                border: none;
                padding: 8px 10px;
                border-radius: 6px;
                cursor: pointer;
                font-size: 13px;
                font-weight: 600;
                font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;            
                transition: all 0.3s ease;        
                width: 40px;
                    justify-content: center;
    align-items: center;
    display: flex;
            
            `;
            
            btn2.onmouseenter = function() {
                this.style.transform = 'scale(1.05)';
             
            };
            btn2.onmouseleave = function() {
                this.style.transform = 'scale(1)';
         
            };
            
            btn2.onclick = function(e) {
                e.preventDefault();
                e.stopPropagation();
                showDataPopup(measurementData, '📏 Measurement Summary');
            };
            
            btnContainer.appendChild(btn2);
        }
        
        // Insert buttons at the top of details area
        // const firstChild = detailsArea.firstChild;
        // if (firstChild) {
        //     detailsArea.insertBefore(btnContainer, firstChild);
        // } else {
        //     detailsArea.appendChild(btnContainer);
        // }
        detailsArea.appendChild(btnContainer)
        console.log(`✅ Buttons added successfully to item ${index}`);
    });
}

// ========================================
// SHOW DATA POPUP
// ========================================

function showDataPopup(data, title) {
    console.log("📊 Showing popup:", title);
    console.log("📊 Data:", data);
    
    // Close any existing popup
    closeCustomizationPopup();
    
    let html = `
    <div class="customization-popup-overlay" id="customizationPopupOverlay" onclick="if(event.target===this)closeCustomizationPopup()">
        <div class="customization-popup-content">
            <div class="customization-popup-header">
                <h2>${title}</h2>
                <button class="customization-popup-close" onclick="closeCustomizationPopup()">×</button>
            </div>
            <div class="customization-popup-body">
    `;
    
    // Create table with all data
    const keys = Object.keys(data).filter(key => data[key] && data[key].trim() !== '');
    
    if (keys.length > 0) {
        html += `<table class="popup-data-table">
                    <thead>
                        <tr>
                            <th>Field</th>
                            <th>Value</th>
                        </tr>
                    </thead>
                    <tbody>`;
        
        keys.forEach(key => {
            const value = data[key];
            if (value && value.trim() !== '') {
                const displayKey = key
                    .replace(/_/g, ' ')
                    .replace(/\b\w/g, l => l.toUpperCase());
                html += `<tr>
                            <td><strong>${displayKey}</strong></td>
                            <td>${value}</td>
                        </tr>`;
            }
        });
        
        html += `</tbody></table>`;
    } else {
        html += `<p style="text-align:center;color:#6b7280;padding:20px;">No data available</p>`;
    }
    
    html += `</div></div></div>`;
    
    document.body.insertAdjacentHTML('beforeend', html);
    document.body.style.overflow = 'hidden';
}

// ========================================
// CLOSE POPUP
// ========================================

function closeCustomizationPopup() {
    const overlay = document.getElementById('customizationPopupOverlay');
    if (overlay) {
        overlay.remove();
        document.body.style.overflow = '';
    }
}

// ========================================
// ADD POPUP CSS
// ========================================

(function addStyles() {
    if (document.getElementById('tailori-popup-styles')) return;
    
    const styles = document.createElement('style');
    styles.id = 'tailori-popup-styles';
    styles.textContent = `
        .customization-popup-overlay {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0,0,0,0.7);
            z-index: 999999;
            display: flex;
            justify-content: center;
            align-items: center;
            animation: fadeIn 0.3s ease;
        }
        
        @keyframes fadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
        }
        
        .customization-popup-content {
            background: white;
            border-radius: 12px;
            max-width: 700px;
            width: 90%;
            max-height: 80vh;
            display: flex;
            flex-direction: column;
            box-shadow: 0 20px 60px rgba(0,0,0,0.3);
            animation: slideUp 0.3s ease;
        }
        
        @keyframes slideUp {
            from { transform: translateY(30px); opacity: 0; }
            to { transform: translateY(0); opacity: 1; }
        }
        
        .customization-popup-header {
            padding: 20px 24px;
            border-bottom: 1px solid #e5e7eb;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        
        .customization-popup-header h2 {
            margin: 0;
            font-size: 20px;
            font-weight: 700;
            color: #1f2937;
        }
        
        .customization-popup-close {
            background: none;
            border: none;
            font-size: 28px;
            cursor: pointer;
            color: #6b7280;
            transition: all 0.2s ease;
            padding: 0 8px;
            line-height: 1;
        }
        
        .customization-popup-close:hover {
            color: #ef4444;
            transform: rotate(90deg);
        }
        
        .customization-popup-body {
            padding: 24px;
            overflow-y: auto;
            flex: 1;
        }
        
        .popup-data-table {
            width: 100%;
            border-collapse: collapse;
            font-size: 14px;
        }
        
        .popup-data-table thead th {
            background: #f9fafb;
            text-align: left;
            padding: 10px 12px;
            font-weight: 600;
            border-bottom: 2px solid #e5e7eb;
            color: #1f2937;
            position: sticky;
            top: 0;
        }
        
        .popup-data-table tbody td {
            padding: 8px 12px;
            border-bottom: 1px solid #f3f4f6;
            color: #374151;
        }
        
        .popup-data-table tbody tr:hover {
            background: #f9fafb;
        }
        
        @media (max-width: 768px) {
            .customization-popup-content {
                max-width: 95%;
                max-height: 90vh;
            }
            
            .customization-popup-header h2 {
                font-size: 17px;
            }
            
            .customization-popup-header {
                padding: 16px 18px;
            }
            
            .customization-popup-body {
                padding: 16px;
            }
            
            .popup-data-table {
                font-size: 12px;
            }
            
            .popup-data-table thead th,
            .popup-data-table tbody td {
                padding: 6px 8px;
            }
        }
    `;
    document.head.appendChild(styles);
    console.log("✅ Popup styles added");
})();

// ========================================
// INITIALIZE - Run on cart page
// ========================================

function initCartButtons() {
    console.log("🚀 Initializing cart buttons...");
    
    if (window.location.pathname.includes('/cart')) {
        console.log("✅ On cart page");
        
        // Add buttons with multiple attempts
        setTimeout(addCartViewButtons, 500);
        setTimeout(addCartViewButtons, 1000);
        setTimeout(addCartViewButtons, 2000);
        setTimeout(addCartViewButtons, 3000);
        setTimeout(addCartViewButtons, 5000);
    } else {
        console.log("ℹ️ Not on cart page");
    }
}

// Run when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartButtons);
} else {
    initCartButtons();
}

// Also run on window load
window.addEventListener('load', function() {
    if (window.location.pathname.includes('/cart')) {
        setTimeout(addCartViewButtons, 1000);
    }
});

// ========================================
// EXPOSE FOR TESTING
// ========================================

window.addCartViewButtons = addCartViewButtons;
window.showDataPopup = showDataPopup;
window.closeCustomizationPopup = closeCustomizationPopup;
window.initCartButtons = initCartButtons;

console.log("✅ Cart buttons script ready!");
console.log("📌 To manually add buttons, run: addCartViewButtons()");